import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail, Phone, Facebook, Youtube } from 'lucide-react';
import { FaWhatsapp} from "react-icons/fa";

const LOGO_URL = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_7012c185-728e-48dd-a634-a866967c4d91/artifacts/4wto96o3_Indo_Travel_25pct_size.png';

export const Footer = () => {
  return (
    <footer style={{
      background: '#070D1E',
      borderTop: '1px solid rgba(251, 191, 36, 0.2)',
      padding: '80px 0 40px'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '60px'
        }}>
          {/* Company Info */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Indotravelista" 
              style={{
                height: '60px',
                width: 'auto',
                marginBottom: '16px',
                filter: 'drop-shadow(0 2px 8px rgba(251, 191, 36, 0.2))'
              }}
            />
            <p className="body-regular" style={{ marginBottom: '16px', color: '#E2E8F0' }}>
              A Jakarta-based luxury DMC crafting bespoke journeys across Indonesia&apos;s hidden and iconic destinations.
            </p>
            <p className="body-small" style={{ marginBottom: '16px', color: '#CBD5E1' }}>
              PT Indotravelista Jelajah Buana<br />
              Duta Harapan Indah MM 8, Kapuk Muara<br />
              Penjaringan, Jakarta Utara 14460
            </p>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <a href="https://facebook.com/indotravelista" target="_blank" rel="noopener noreferrer" 
                 style={{ color: '#FBBF24', transition: 'all 0.2s' }}
                 className="social-icon">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/indotravelistar/" target="_blank" rel="noopener noreferrer" 
                 style={{ color: '#FBBF24', transition: 'all 0.2s' }}
                 className="social-icon">
                <Instagram size={20} />
              </a>
              <a href="https://youtube.com/@indotravelista" target="_blank" rel="noopener noreferrer"
                 style={{ color: 'var(--text-primary)', transition: 'opacity 0.2s' }}
                 onMouseEnter={(e) => e.target.style.opacity = '0.6'}
                 onMouseLeave={(e) => e.target.style.opacity = '1'}>
                <Youtube size={20} />
              </a>
              <a href="https://linkedin.com/company/indotravelista" target="_blank" rel="noopener noreferrer"
                 style={{ color: 'var(--text-primary)', transition: 'opacity 0.2s' }}
                 onMouseEnter={(e) => e.target.style.opacity = '0.6'}
                 onMouseLeave={(e) => e.target.style.opacity = '1'}>
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '16px' }}>Explore</h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><Link to="/indonesia-journeys" className="footer-link">Indonesia Journeys</Link></li>
              <li><Link to="/worldwide-journeys" className="footer-link">Worldwide Journeys</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '16px' }}>Services</h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><Link to="/b2b" className="footer-link">B2B Partnerships</Link></li>
              <li><Link to="/contact" className="footer-link">Plan Your Journey</Link></li>
              <li><Link to="/about" className="footer-link">Event & Incentive Travel</Link></li>
              <li><Link to="/about" className="footer-link">Private Groups</Link></li>
              <li><Link to="/about" className="footer-link">MICE Services</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '16px' }}>Connect</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="mailto:info@indotravelista.com" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} />
                info@indotravelista.com
              </a>
              <a href="tel:+6281517118799" className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} />
                +6281517118799
              </a>
              <a 
                href="https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20would%20like%20to%20inquire%20about%20a%20journey." 
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link" 
                style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#25D366', fontWeight: 500 }}
              >
                <FaWhatsapp size={16} />
                WhatsApp Us
              </a>
              <p className="body-small" style={{ marginTop: '8px', color: 'var(--text-secondary)' }}>
                Jakarta, Indonesia
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '32px',
          textAlign: 'center'
        }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            &copy; {new Date().getFullYear()} PT Indotravelista Jelajah Buana. All rights reserved. Live the Journey — Create Memories That Last Forever.
          </p>
        </div>
      </div>

      <style>{`
        .footer-link {
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 14px;
          transition: color 0.2s ease;
        }
        
        .footer-link:hover {
          color: var(--text-primary);
        }
      `}</style>
    </footer>
  );
};
